import { motion } from "motion/react";
import { Menu, X, Shield } from "lucide-react";
import { useState } from "react";

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToOnboarding = () => {
    const onboardingSection = document.getElementById('onboarding');
    if (onboardingSection) {
      onboardingSection.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center gap-2"
          >
            <div className="w-10 h-10 rounded-lg overflow-hidden flex items-center justify-center">
              <img
                src="/favicon-512x512.png"
                alt="PGVCL Logo"
                className="w-full h-full object-contain"
              />
            </div>

          </motion.div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#why-green" className="text-gray-600 hover:text-emerald-600 transition-colors">
              Why Green
            </a>
            <a href="#energy-breakdown" className="text-gray-600 hover:text-emerald-600 transition-colors">
              Energy Mix
            </a>
            <a href="#compliance" className="text-gray-600 hover:text-emerald-600 transition-colors">
              Voluntary
            </a>
            <a href="#certificate" className="text-gray-600 hover:text-emerald-600 transition-colors">
              Certificate
            </a>
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <motion.a
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.1 }}
              href="/verify"
              className="flex items-center gap-2 px-6 py-3 bg-white border-2 border-emerald-500 text-emerald-600 rounded-lg hover:bg-emerald-50 transition-all"
            >
              <Shield className="w-4 h-4" />
              Verify Certificate
            </motion.a>
  
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-600 hover:text-emerald-600"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="md:hidden py-4 space-y-4 border-t border-gray-100"
          >
            <a href="#why-green" className="block text-gray-600 hover:text-emerald-600 transition-colors">
              Why Green
            </a>
            <a href="#energy-breakdown" className="block text-gray-600 hover:text-emerald-600 transition-colors">
              Energy Mix
            </a>
            <a href="#compliance" className="block text-gray-600 hover:text-emerald-600 transition-colors">
              Voluntary
            </a>
            <a href="#certificate" className="block text-gray-600 hover:text-emerald-600 transition-colors">
              Certificate
            </a>
            <a
              href="#certificate"
              onClick={() => setMobileMenuOpen(false)}
              className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-white border-2 border-emerald-500 text-emerald-600 rounded-lg"
            >
              <Shield className="w-4 h-4" />
              Verify Certificate
            </a>
          </motion.div>
        )}
      </div>
    </header>
  );
}
